import React, { MouseEvent } from 'react';
import { RootStateOrAny, useSelector } from 'react-redux';
import { queryIndexes } from '../actions/initialActions';

export const Xrefs = (props: { starter: string, linkTo: string }) => {
    const fy = useSelector((state: RootStateOrAny) => state.fy)

    const handleClick = (event: MouseEvent) => {
        event.preventDefault();
        queryIndexes(props.linkTo, fy)
    }

    return (
        <span className="crossreference">{props.starter}<span onClick={handleClick} className="code-link strong">{props.linkTo}</span></span>
    )
}